import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifySessionKbaMutation } from '@onefootprint/fetch-hosted';
import type { IdentifyRequirementLogin } from '@onefootprint/request-types';
import { Button, Form, PageShell } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { isSessionExpired } from '@/idv2/features/identify/handle-session-expired';
import { renderScrubbedText } from '@/idv2/features/identify/render-scrubbed-text';
import { useVaultErrorMessage } from '@/idv2/features/identify/use-vault-error-message';
export type PhoneKbaChallengeProps = {
  loginRequirement: IdentifyRequirementLogin;
  onboardingSessionToken: string;
  defaultPhone?: string;
  onSuccess: () => void;
  onError?: (error: unknown) => void;
};
type PhoneKbaFormData = {
  phone: string;
};
export const PhoneKbaChallenge = t0 => {
  const $ = _c(54);
  const {
    loginRequirement,
    onboardingSessionToken,
    defaultPhone,
    onSuccess,
    onError
  } = t0;
  const {
    t,
    i18n
  } = useTranslation("idv2");
  const locale = i18n.language === "es" ? "es-MX" : "en-US";
  const getVaultErrorMessage = useVaultErrorMessage();
  let t1;
  let t2;
  if ($[0] !== onboardingSessionToken) {
    const headers = {
      "X-Fp-Authorization": onboardingSessionToken
    };
    t1 = useMutation;
    t2 = postHostedIdentifySessionKbaMutation({
      headers
    });
    $[0] = onboardingSessionToken;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const mutation = t1(t2);
  const t3 = defaultPhone ?? "";
  let t4;
  if ($[3] !== t3) {
    t4 = {
      defaultValues: {
        phone: t3
      }
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const methods = useForm(t4);
  const t5 = loginRequirement.user?.scrubbedPhone ?? "";
  let T0;
  let handleSubmit;
  let t6;
  let t7;
  if ($[5] !== getVaultErrorMessage || $[6] !== methods || $[7] !== mutation || $[8] !== onError || $[9] !== onSuccess || $[10] !== t || $[11] !== t5) {
    const lastFourDigits = t5.slice(-4).replace(/\*/g, "\u2022");
    let t8;
    if ($[16] !== getVaultErrorMessage || $[17] !== methods || $[18] !== mutation || $[19] !== onError || $[20] !== onSuccess) {
      t8 = async data => {
        ;
        try {
          await mutation.mutateAsync({
            body: {
              "id.phone_number": data.phone
            }
          });
          onSuccess();
        } catch (t9) {
          const error = t9;
          if (isSessionExpired(error)) {
            onError?.(error);
            return;
          }
          const message = getVaultErrorMessage(error, "id.phone_number");
          if (message) {
            methods.setError("phone", {
              message
            });
          }
        }
      };
      $[16] = getVaultErrorMessage;
      $[17] = methods;
      $[18] = mutation;
      $[19] = onError;
      $[20] = onSuccess;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    handleSubmit = t8;
    T0 = PageShell;
    if ($[22] !== t) {
      t6 = t(_temp);
      $[22] = t;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t7 = renderScrubbedText(t(_temp2, {
      digits: lastFourDigits
    }));
    $[5] = getVaultErrorMessage;
    $[6] = methods;
    $[7] = mutation;
    $[8] = onError;
    $[9] = onSuccess;
    $[10] = t;
    $[11] = t5;
    $[12] = T0;
    $[13] = handleSubmit;
    $[14] = t6;
    $[15] = t7;
  } else {
    T0 = $[12];
    handleSubmit = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[24] !== handleSubmit || $[25] !== methods) {
    t8 = methods.handleSubmit(handleSubmit);
    $[24] = handleSubmit;
    $[25] = methods;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t) {
    t9 = t(_temp3);
    $[27] = t;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t(_temp4);
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10) {
    t11 = {
      required: t10
    };
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== locale || $[34] !== t11 || $[35] !== t9) {
    t12 = <Form.Tel label={t9} name="phone" locale={locale} rules={t11} />;
    $[33] = locale;
    $[34] = t11;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const t13 = mutation.isPending;
  const t14 = mutation.isPending;
  let t15;
  if ($[37] !== t) {
    t15 = t(_temp5);
    $[37] = t;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== mutation.isPending || $[40] !== t15) {
    t16 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={t13} disabled={t14}>{t15}</Button>;
    $[39] = mutation.isPending;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t12 || $[43] !== t16 || $[44] !== t8) {
    t17 = <form onSubmit={t8} className="flex flex-col gap-4 w-full">{t12}{t16}</form>;
    $[42] = t12;
    $[43] = t16;
    $[44] = t8;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== methods || $[47] !== t17) {
    t18 = <FormProvider {...methods}>{t17}</FormProvider>;
    $[46] = methods;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== T0 || $[50] !== t18 || $[51] !== t6 || $[52] !== t7) {
    t19 = <T0 title={t6} subtitle={t7}>{t18}</T0>;
    $[49] = T0;
    $[50] = t18;
    $[51] = t6;
    $[52] = t7;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
};
function _temp($) {
  return $.identify.kba.title;
}
function _temp2($_0) {
  return $_0.identify.kba.subtitle;
}
function _temp3($_1) {
  return $_1.identify.phone.label;
}
function _temp4($_2) {
  return $_2.identify.phone.requiredError;
}
function _temp5($_3) {
  return $_3.identify.phone.continue;
}